// @ts-nocheck
import {Percent, CurrencyUSD, Time, GraphQLDecimal} from '@/graphql/scalars'

import * as Types from '../../../../types/schema';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type AdminSummaryPromptsPage_DocumentSummaryPromptFragment = { __typename?: 'DocumentSummaryPrompt', id: string, displayName: string, documentType: Types.DocumentSummaryPromptDocumentType, isSystemPrompt: boolean, shouldAutoRun: boolean, isDefaultForDocType: boolean, createdByUser: { __typename?: 'User', id: string, firstName: string, lastName: string } };

export type AdminSummaryPromptsPageQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type AdminSummaryPromptsPageQuery = { __typename?: 'Query', documentSummaryPrompts: { __typename?: 'DocumentSummaryPromptConnection', edges?: Array<{ __typename?: 'DocumentSummaryPromptEdge', node?: (
        { __typename?: 'DocumentSummaryPrompt' }
        & AdminSummaryPromptsPage_DocumentSummaryPromptFragment
      ) | null } | null> | null } };

export const Operations = {
  Query: {
    AdminSummaryPromptsPage: 'AdminSummaryPromptsPage' as const
  },
  Fragment: {
    AdminSummaryPromptsPage_DocumentSummaryPrompt: 'AdminSummaryPromptsPage_DocumentSummaryPrompt' as const
  }
}

/**
 * Custom plugin to wrap useQuery hooks with automatic context.fetchPolicy injection
 */
function withFetchPolicyContext(options) {
  const fetchPolicy = options?.fetchPolicy ?? 'cache-first';
  const isLazy = options?.isLazy ?? undefined;
  return {
    ...options,
    context: {
      ...options?.context,
      fetchPolicy,
      isLazy,
    },
  };
}

/**
 * Defaults useSubscription to ignoreResults: true so Apollo skips its
 * per-message useSyncExternalStore notification (forceStoreRerender). All
 * call sites manage state via onData; opting out avoids render storms when
 * messages arrive in a synchronous burst. See T2-10011. Callers that need
 * Apollo to surface data/loading/error can override by passing
 * ignoreResults: false explicitly.
 */
function withSubscriptionIgnoreResults(options) {
  return {
    ignoreResults: true,
    ...options,
  };
}

export const AdminSummaryPromptsPage_DocumentSummaryPromptFragmentDoc = gql`
    fragment AdminSummaryPromptsPage_DocumentSummaryPrompt on DocumentSummaryPrompt {
  id
  displayName
  documentType
  isSystemPrompt
  shouldAutoRun
  isDefaultForDocType
  createdByUser: user {
    id
    firstName
    lastName
  }
}
    `;
export const AdminSummaryPromptsPageDocument = gql`
    query AdminSummaryPromptsPage {
  documentSummaryPrompts(first: 500) {
    edges {
      node {
        ...AdminSummaryPromptsPage_DocumentSummaryPrompt
      }
    }
  }
}
    ${AdminSummaryPromptsPage_DocumentSummaryPromptFragmentDoc}`;

/**
 * __useAdminSummaryPromptsPageQuery__
 *
 * To run a query within a React component, call `useAdminSummaryPromptsPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminSummaryPromptsPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminSummaryPromptsPageQuery({
 *   variables: {
 *   },
 * });
 */
export function useAdminSummaryPromptsPageQuery(baseOptions?: Apollo.QueryHookOptions<AdminSummaryPromptsPageQuery, AdminSummaryPromptsPageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminSummaryPromptsPageQuery, AdminSummaryPromptsPageQueryVariables>(AdminSummaryPromptsPageDocument, withFetchPolicyContext(options));
      }
export function useAdminSummaryPromptsPageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AdminSummaryPromptsPageQuery, AdminSummaryPromptsPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminSummaryPromptsPageQuery, AdminSummaryPromptsPageQueryVariables>(AdminSummaryPromptsPageDocument, withFetchPolicyContext({ ...options, isLazy: true }));
        }
export function useAdminSummaryPromptsPageSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<AdminSummaryPromptsPageQuery, AdminSummaryPromptsPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AdminSummaryPromptsPageQuery, AdminSummaryPromptsPageQueryVariables>(AdminSummaryPromptsPageDocument, withFetchPolicyContext(options));
        }
export type AdminSummaryPromptsPageQueryHookResult = ReturnType<typeof useAdminSummaryPromptsPageQuery>;
export type AdminSummaryPromptsPageLazyQueryHookResult = ReturnType<typeof useAdminSummaryPromptsPageLazyQuery>;
export type AdminSummaryPromptsPageSuspenseQueryHookResult = ReturnType<typeof useAdminSummaryPromptsPageSuspenseQuery>;
export type AdminSummaryPromptsPageQueryResult = Apollo.QueryResult<AdminSummaryPromptsPageQuery, AdminSummaryPromptsPageQueryVariables>;